/* ============================================================================
   RK SCHUBLADE — Plus-Knopf „gleich mitnehmen“ in der eigenen Warenkorb-Schublade

   Die Schublade wird nach jeder Änderung neu gezeichnet, darum hört das Skript
   am Dokument mit statt an den Knöpfen. Ein Tipp legt das Teil in den Korb
   und zeichnet die Schublade mit dem neuen Inhalt (renderContents des Themes).
   Powered by René Kress - Crovio · www.crovio.de
   ========================================================================= */
(function () {
  'use strict';
  if (window.rkSchubladeBereit) return;
  window.rkSchubladeBereit = true;

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-rk-sd-plus]');
    if (!knopf || knopf.disabled) return;
    var schublade = document.querySelector('cart-drawer');
    knopf.disabled = true;
    knopf.classList.add('is-laedt');

    var daten = new FormData();
    daten.append('id', knopf.getAttribute('data-rk-sd-plus'));
    daten.append('quantity', '1');
    daten.append('sections', 'cart-drawer,cart-icon-bubble');
    daten.append('sections_url', window.location.pathname);

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: daten
    })
      .then(function (a) { return a.json().then(function (j) { return { ok: a.ok, j: j }; }); })
      .then(function (r) {
        if (!r.ok || r.j.status) throw new Error(r.j.description || 'Fehler');
        var korbseite = window.location.pathname === ((window.routes && window.routes.cart_url) || '/cart');
        if (korbseite) { window.location.reload(); return; }
        if (schublade && r.j.sections) { schublade.classList.remove('is-empty'); schublade.renderContents(r.j); }
        document.dispatchEvent(new CustomEvent('rk:warenkorb-geaendert'));
      })
      .catch(function () {
        knopf.disabled = false;
        knopf.classList.remove('is-laedt');
      });
  });
})();
